import styled from 'styled-components';

export const NodesEditorContainer = styled.div`
	display: flex;
	flex-direction: column;

    gap: ${p => p.theme.styles.padding}px;
`;